
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-view-multiple-choice-v1',
    templateUrl: './view-multiple-choice-v1.component.html'
})
export class ViewMultipleChoiceV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;


    ngOnInit(): void {
    }

}
